<template>
  <div class="volumechooser">
    <div class="volumechooser-inner">
      <a class="volumechooser-book" v-for="b in books" :key="`vc-${b.Id}`" @click="select(b)">
        <div class="volumechooser-book-left" v-html="b.Options.Author"/>
        <div class="volumechooser-book-right">
          <p v-html="b.Name"/>
          <p v-html="b.Options.Subtitle"/>
        </div>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VolumeChooser',
  computed: {
    books () {
      return this.$root.volumeChoice || []
    }
  },
  methods: {
    select (book) {
      this.$root.selectVolume(book)
    }
  }
}
</script>

<style lang="scss">

@import '../main';

.volumechooser {
  z-index: 5000;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  @include flex-vertical-center;
  backdrop-filter: blur(var(--padding-05));
  &-inner {
    width: 40vw;
    min-width: 600px;
    @include sm() {
      width: 80vw;
      min-width: auto;
    }
    box-sizing: border-box;
    background: var(--context-tray-color);
    color: var(--context-tray-font-color);
    @include tocfont();
    text-transform: uppercase;
    border: 1px solid var(--context-tray-font-color);
  }
  &-book {
    display: flex;
    position: relative;
    cursor: pointer;
    padding-top: var(--padding-05);
    border-top: 1px solid var(--context-tray-font-color);
    padding: var(--padding);
    &:first-child {
      border-top: none;
      margin-top: 0;
    }
    &:active,
    &:focus,
    &:hover {
      color: inherit !important;
      transition: all 0.25s;
    }
    // marker sits in the gutter so hovering does not shift the entry
    &:hover {
      background: white;
    }
    p {
      margin: 0;
      padding: 0;
      &:last-child {
        font-style: italic;
      }
    }
    &-left,
    &-right {
      flex-basis: 50%;
    }
    @include sm() {
      display: block;
      &-left,
      &-right {
        display: block;
        width: 100%;
      }
      &-right {
        margin-top: var(--padding-05);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VolumeChooser.vue